import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Elevation, Grid, GridCell, Button, Typography, Icon } from 'rmwc';

import { currencyFormatter, Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { Text } from '../../components/Text';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';

import LetterScore from '../../components/charts/LetterScore';
import AssetBalanceChart from '../../components/charts/AssetBalanceChart';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchSavingsModule } from '../../actions/savingsActions';

import FinancialShockSidebar from './FinancialShockSidebar';

import { CTAOpt } from '../../components/Onboarding/CtaVariants';

import {
  MTHeader,
  MTSkinny,
  MTSubheading,
  MTSubcontent,
  MTSubcontentP,
  MTDivider,
  MTSubcontentHR,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentLabel,
  MTScorePanel,
  MTCTA,
  MTCTAv2,
  MTLearnMore,
  MTLearnMoreItem,
} from './layout';
import { wlPath } from '../../helpers/whitelabel';

export class FinancialShock extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }
    this.fetchData();
  }

  fetchData = () => {
    this.props.fetchSavingsModule();
    this.props.fetchPeople();
  };

  calcRetirementFeeSaving = () => {
    if (this.props.updatedResults && this.props.people) {
      const primaryAge = this.props.people[0].age;
      const retirementAge = 67;
      const yearsUntilRetirement = retirementAge - primaryAge;
      // person already retired
      if (yearsUntilRetirement <= 0) {
        return 0;
      }
      const savingsAmount =
        this.props.results.distribution.asset_balance.average[yearsUntilRetirement - 1] -
        this.props.updatedResults.distribution.asset_balance.average[yearsUntilRetirement - 1];
      return savingsAmount;
    }
    return 0;
  };

  render() {
    const { people, results, onContinue, openRegistrationDialog, openEmailDialog, history, savings } = this.props;

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    if (!results || !savings) {
      return null;
    }
    return (
      <div>
        <MTHeader title="Protect against a Financial Shock" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubheading title="What is a financial shock, and why does it matter?" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              The markets have done well since 2009. However, they’re now at all-time highs, and the economy is
              increasingly unsteady. An unexpected change would erase the progress you’ve made, just as you’re thinking
              of cashing in.
            </MTSubcontentP>
            <MTSubcontentP last>
              <strong>Without the right strategy, a financial shock could set back your retirement.</strong>
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="How much could a financial shock affect my retirement?" />
          <MTSubcontent>
            <MTSubcontentH1 title="Financial shock calculator" />
            <MTSubcontentLabel>Use the menu to see another financial shock.</MTSubcontentLabel>
            <FinancialShockSidebar />
            <MTSubcontentHR />
            <MTSubcontentH2 title="Your total net worth" />
            <AssetBalanceChart
              initial={this.props.results}
              updated={this.props.updatedResults}
              primaryPerson={this.props.primaryPerson}
              beforeLegend="Without Shock"
              afterLegend="With Shock"
            />
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="Protect yourself against a major shock" />
          <MTCTAv2
            title="Want help getting started? Get a free risk review."
            subtitle="Take just 15 minutes to protect your retirement."
            image={require('images/outcome-fees.png')}
            description="We'll learn about your risk profile, then compare it to your actual portfolio. If your investments are more risky than you realize, we'll recommend trades to bring that back in line."
            buttonTextSecondary="Save for Later"
            onClickSecondary={() =>
              this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
            }
            buttonTextPrimary="Learn More"
            onClickPrimary={() => this.props.history.push(`/start/investment-fees/analysis`)}
            talkingPointsHeading="Get started with these first steps"
            talkingPointsSubheading="Here are some tips to get you started"
            talkingPointsImage={require('images/icon-situation')}
            talkingPoints={[
              {
                image: require('images/outcome-fees.png'),
                label: 'Decide what level of risk is appropriate for you.',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      Knowing how willing you are to ride out the disruptions of the financial markets is important in
                      deciding how to protect against a financial shock, and how to manage your money in general.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      Markets inevitably will go up &mdash; and go down &mdash; when it goes down, some investments are
                      hurt worse than others. Knowing how you will react in these situations and how you want to react
                      in these situations helps to determine how best to design an investment strategy.
                    </Text>
                  </div>
                ),
              },
              {
                image: require('images/icon-questions.png'),
                label: 'Show you the best strategies to protect against a shock.',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      Protecting against a shock can run the range from putting your money under your mattress to using
                      guaranteed income to buying actively managed mutual funds.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      What’s best for you depends on a lot about your goals and your financial situation. In some cases,
                      because of how much you have saved and where you have it saved, you can afford to ride our a
                      financial shock over time, without too many changes to your portfolio. However, sometimes taking
                      precautions for what happens in a downside can go a long way
                    </Text>
                  </div>
                ),
              },
              {
                image: require('images/icon-options.png'),
                label: 'Show you how to keep track of your risk going forward.',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      There is no easy answer to this. It’s important to check how your investment balance changes over
                      time and when you are becoming “over-exposed” to investments that have a risk of going down. It
                      takes monitoring the quality of your investments and matching the quality against the current and
                      prospective market environment. No one has a crystal ball about what will happen in the future,
                      but there are ways to be smarter about things then just “letting it ride,” like a roll of the
                      dice.
                    </Text>
                  </div>
                ),
              },
            ]}
          />
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="Learn more" />
          <MTLearnMore>
            <MTLearnMoreItem title="Isn’t it worth paying higher fees if that means better quality advice?">
              <Text use="body1" tag="p">
                Higher fees can sometimes be justified if the fund manager is very good at picking investments and their
                investment returns are better than other funds, even after their fees (this is called a "net return").
              </Text>
              <Text use="body1" tag="p">
                However, this is very rarely the case. A{' '}
                <a href="http://news.morningstar.com/articlenet/article.aspx?id=752485" target="_blank">
                  recent analysis by Morningstar
                </a>{' '}
                found that the more expensive a fund is, the worse the net return. This is true for all asset classes
                they studied!
              </Text>
              <Text use="body1" tag="p">
                If you sign up for our <strong>Free fee analysis</strong>, you'll have a chance to discuss whether your
                fund's performance justifies the higher fees.
              </Text>
              <Text use="body1" tag="p" className="pb-1">
                <strong>
                  But generally, if a cheaper fund is doing the same thing for less (and actually performs better), why
                  not use the lower cost one?
                </strong>
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="What are investment fund fees and why do they exist?">
              <Text use="body1" tag="p" className="pb-1">
                Investment fund fees are fees paid for "hiring" a company to invest your money for you in a certain way.
                They exist to pay the salaries of the people picking the individual stocks and bonds into which you
                money is invested and to pay for the operating costs of the fund such as technology, trading, and
                compliance costs.
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="Why are some fees higher than others?">
              <Text use="body1" tag="p" className="pb-1">
                Some companies charge more because their funds are in greater demand. Others charge more because they
                believe they devote more time and care into making investments for you and believe their fund is
                different than other funds. The size of company also matters. A bigger company with simpler funds
                usually charges you less, because they have many more customers. Smaller companies usually have to
                charge more to stay in business, but often offer a more unique fund in return.
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="Where do I look to see the fees I am currently paying today?">
              <Text use="body1" tag="p" className="pb-1">
                You can look in the prospectus of any fund in which you are invested and it will tell you the fees that
                are charged. However, you won’t see this fee withdrawn in an obvious way. It is usually withdrawn net of
                your investment fees, so you don't see the specific amount you paid unless you examine closely. You can
                also use an expert to help you determine how much you are paying.
              </Text>
            </MTLearnMoreItem>
          </MTLearnMore>
        </MTSkinny>
      </div>
    );
  }
}

function getPrimaryPerson(people, dashboard) {
  if (!people.fetched || !dashboard.fetched) {
    return null;
  }
  for (const person of people.data) {
    if (person.id == dashboard.data.primary_person_id) {
      return person;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    people: state.people.data,
    results: state.simulations.results,
    primaryPerson: getPrimaryPerson(state.people, state.modules.dashboard),
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
    savings: state.modules.savings.data,
  };
}

function mapDispatchToProps() {
  return {
    runFullSimulation,
    fetchDashboard,
    fetchPeople,
    fetchSavingsModule,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(withEmailDialog(withRegistrationDialog(FinancialShock)));
